import { AttendanceChannel } from '../interfaces/attendance';

//TODO: get the icon references
export const CHANNEL_ICON_MAP = {
  [AttendanceChannel.CHAT_WEB]: 'assets/icons/channels/chat_web.svg',
  [AttendanceChannel.WHATSAPP]: 'assets/icons/channels/whatsapp.svg',
  [AttendanceChannel.FACEBOOK]: 'assets/icons/channels/facebook.svg', //TODO: this has wrong image, it is a meta messager logo
  [AttendanceChannel.INSTAGRAM]: 'assets/icons/channels/instagram_purple.svg',
  [AttendanceChannel.GOOGLE_BUSINESS_MESSAGES]:
    'assets/icons/channels/google_business_messages.svg',
  [AttendanceChannel.EMAIL]: 'assets/icons/channels/email.svg',
  [AttendanceChannel.PHONE]: 'assets/icons/channels/phone.svg',
  [AttendanceChannel.BOOKING]: 'assets/icons/channels/booking.svg',
  [AttendanceChannel.EXPEDIA]: 'assets/icons/channels/expedia.svg',
  [AttendanceChannel.TIKTOK]: 'assets/icons/channels/tiktok.svg',
  [AttendanceChannel.TELEGRAM]: 'assets/icons/channels/telegram.svg',
};

/**
 * WhatsApp glyph of the coexistence design (TAS-525). Not the channel's default
 * logo: only the card of an attendance held by WhatsApp Web and the chat-info of
 * a bubble typed on the WhatsApp Business app use it.
 */
export const WHATSAPP_COEX_CHANNEL_ICON = 'assets/icons/channels/whatsapp_coex.svg';

export const CHANNEL_NAME_MAP = {
  [AttendanceChannel.CHAT_WEB]: 'CHANNELS.chat_web',
  [AttendanceChannel.WHATSAPP]: 'CHANNELS.whatsapp',
  [AttendanceChannel.FACEBOOK]: 'CHANNELS.facebook',
  [AttendanceChannel.INSTAGRAM]: 'CHANNELS.instagram',
  [AttendanceChannel.GOOGLE_BUSINESS_MESSAGES]: 'CHANNELS.google_business_messages',
  [AttendanceChannel.EMAIL]: 'CHANNELS.email',
  [AttendanceChannel.PHONE]: 'CHANNELS.phone',
  [AttendanceChannel.BOOKING]: 'CHANNELS.booking',
  [AttendanceChannel.EXPEDIA]: 'CHANNELS.expedia',
  [AttendanceChannel.TIKTOK]: 'CHANNELS.tiktok',
  [AttendanceChannel.TELEGRAM]: 'CHANNELS.telegram',
};

export const META_COMPANY_CHANNELS = [
  AttendanceChannel.WHATSAPP,
  AttendanceChannel.FACEBOOK,
  AttendanceChannel.INSTAGRAM,
];

export const CHANNELS_WITH_FILE_UPLOAD = [
  AttendanceChannel.WHATSAPP,
  AttendanceChannel.INSTAGRAM,
  AttendanceChannel.TIKTOK,
  AttendanceChannel.TELEGRAM,
];

export const CHANNELS_WITH_AUDIO_RECORD = [
  AttendanceChannel.WHATSAPP,
  AttendanceChannel.TELEGRAM,
];

export const CHANNELS_WITH_REPLY = [
  AttendanceChannel.WHATSAPP,
  AttendanceChannel.TELEGRAM,
];

//TODO: ja existe um enum de filtros aqui: src/app/modules/live-chat/interfaces/attendance.ts:33
export const AVAILABLE_CHANNEL_FILTERS = [
  AttendanceChannel.INSTAGRAM,
  AttendanceChannel.FACEBOOK,
  AttendanceChannel.WHATSAPP,
  AttendanceChannel.CHAT_WEB,
  AttendanceChannel.PHONE,
  AttendanceChannel.EMAIL,
  AttendanceChannel.BOOKING,
  AttendanceChannel.EXPEDIA,
  AttendanceChannel.TIKTOK,
  AttendanceChannel.TELEGRAM,
];